var ordersData = [{
  Status: "Completed",
  OrderNumber: "17711249595187200",
  OrderDate: "Apr 19, 2023",
  Id: "Entity-Order-e2cf3f97bbf24477a641331e12895e94",
  CartLines: [{
    Id: "169027dd367841a7b2339827136de506",
    Product: {
      SitecoreId: "90a58e8a-23ec-7cf1-cd23-2c6a01f5f252",
      ProductChainId: "486175",
      StoreProductId: "16395128",
      ProductVariantId: null,
      DisplayName: "Coca-Cola®",
      AvailableInventory: 0,
      CurrencySymbol: "USD",
      ListPrice: 0,
      AdjustedPrice: null,
      ImageFilePath: "https://olo-images-sandbox.imgix.net/87/87d842dcac634631a5b7ccfa20812b75.jpg?auto=format%2Ccompress&q=60&cs=tinysrgb&w=120&h=120&fit=fill&fm=png32&bg=transparent&s=361573af8ce60f426fae0e7f6dd6f0e2",
      MinimumQuantity: "1",
      MaximumQuantity: "0",
      MinimumBasketQuantity: "0",
      MaximumBasketQuantity: "0",
      DetailLink: "/menu/drinks/sodas/coca-cola®?productid=16395128",
      CatalogName: "CB_Food_Store",
      ProductVariantModel: null,
      AdvanceNoticeTimeInHours: "0"
    },
    Quantity: 1,
    Price: {
      CurrencyCode: "USD",
      CurrencySymbol: "$",
      Total: 0,
      Subtotal: 2.99,
      HandlingTotal: 0,
      ShippingTotal: 0,
      TaxTotal: 0,
      TotalSavings: 0,
      OloTip: null,
      OloCateringTip: null
    },
    Options: null,
    LineCost: 2.99,
    OloBasketId: "27780cf6-6e16-4b30-aeec-35ffad250a32",
    OloBasketProductId: "10038164193",
    Recipient: null,
    SpecialInstruction: null,
    LineOptions: null,
    TrackingNumber: null,
    AddOnProductDetails: null,
    ReturnDetails: {
      Quantity: 0,
      ReturnWindowExpired: false,
      Status: "",
      IsReturnInitiated: false,
      Reason: ""
    }
  }],
  Price: {
    CurrencyCode: "USD",
    CurrencySymbol: "$",
    GiftCardTotal: 3.28,
    Total: 3.28,
    Subtotal: 2.99,
    HandlingTotal: 0,
    ShippingTotal: 0,
    TaxTotal: 0,
    TotalSavings: 0,
    OloTip: null,
    OloCateringTip: null
  },
  Adjustments: [],
  Email: null,
  Addresses: [{
    Name: "",
    FirstName: "Esteban",
    LastName: "Flores",
    Address1: "28 DAMRELL STREET, SUITE 300",
    Address2: "",
    Country: "",
    CountryCode: "",
    City: "Boston",
    State: "",
    ZipPostalCode: "02127",
    ExternalId: "",
    PartyId: "",
    IsPrimary: false,
    Email: "esteban.flores@verndale.com",
    ContactId: null
  }, {
    Name: "",
    FirstName: "Esteban",
    LastName: "Flores",
    Address1: "28 DAMRELL STREET, SUITE 300",
    Address2: "",
    Country: "",
    CountryCode: "",
    City: "Boston",
    State: "",
    ZipPostalCode: "02127",
    ExternalId: "",
    PartyId: "",
    IsPrimary: false,
    Email: "esteban.flores@verndale.com",
    ContactId: null
  }],
  Shippings: null,
  Options: null,
  OloFoodStoreBasketId: null,
  OloCateringStoreBasketId: null,
  OloErrors: null,
  FoodDelivery: null,
  OloDiscount: null,
  OloStoreComponent: {
    StoreName: "Lab 1020",
    StoreNumber: "1020",
    StoreAddress: "305 Hartmann Drive",
    StoreCity: "Lebanon",
    State: "TN",
    ZipCode: "37087",
    StorePhone: "6154445533",
    MerchantId: null,
    VendorId: "143963",
    StoreTimeZone: "-5",
    Id: "a7cffc94025648f597ec2e08a6a8f83e",
    Name: "",
    Comments: "",
    Policies: [],
    ChildComponents: []
  },
  UserIp: null,
  DisplayMessages: null,
  UpsellCrossSellCategories: null,
  IsTokenExEnabled: false
}, {
  Status: "Completed",
  OrderNumber: "17574530122743811",
  OrderDate: "Apr 13, 2023",
  Id: "Entity-Order-409bf2e0977d4499b87ab64fe3e852aa",
  CartLines: [{
    Id: "b4de4f9846cb474e9e4b33eacef62fc9",
    Product: {
      SitecoreId: null,
      ProductChainId: null,
      StoreProductId: "40510276",
      ProductVariantId: null,
      DisplayName: null,
      AvailableInventory: 0,
      CurrencySymbol: null,
      ListPrice: null,
      AdjustedPrice: null,
      ImageFilePath: null,
      MinimumQuantity: null,
      MaximumQuantity: null,
      MinimumBasketQuantity: null,
      MaximumBasketQuantity: null,
      DetailLink: null,
      CatalogName: "CB_Food_Store",
      ProductVariantModel: null,
      AdvanceNoticeTimeInHours: null
    },
    Quantity: 1,
    Price: {
      CurrencyCode: "USD",
      CurrencySymbol: "$",
      Total: 0,
      Subtotal: 15.99,
      HandlingTotal: 0,
      ShippingTotal: 0,
      TaxTotal: 0,
      TotalSavings: 0,
      OloTip: null,
      OloCateringTip: null
    },
    Options: null,
    LineCost: 15.99,
    OloBasketId: "48c272d3-cd9b-4ff5-a2d6-3c27110f2d39",
    OloBasketProductId: "15939039897",
    Recipient: null,
    SpecialInstruction: null,
    LineOptions: null,
    TrackingNumber: null,
    AddOnProductDetails: null,
    ReturnDetails: {
      Quantity: 0,
      ReturnWindowExpired: false,
      Status: "",
      IsReturnInitiated: false,
      Reason: ""
    }
  }],
  Price: {
    CurrencyCode: "USD",
    CurrencySymbol: "$",
    GiftCardTotal: 17.55,
    Total: 17.55,
    Subtotal: 15.99,
    HandlingTotal: 0,
    ShippingTotal: 0,
    TaxTotal: 0,
    TotalSavings: 0,
    OloTip: null,
    OloCateringTip: null
  },
  Adjustments: [],
  Email: null,
  Addresses: [{
    Name: "",
    FirstName: "Esteban",
    LastName: "Flores",
    Address1: "28 DAMRELL STREET, SUITE 300",
    Address2: "",
    Country: "",
    CountryCode: "",
    City: "Boston",
    State: "",
    ZipPostalCode: "02127",
    ExternalId: "",
    PartyId: "",
    IsPrimary: false,
    Email: "esteban.flores@verndale.com",
    ContactId: null
  }, {
    Name: "",
    FirstName: "Esteban",
    LastName: "Flores",
    Address1: "28 DAMRELL STREET, SUITE 300",
    Address2: "",
    Country: "",
    CountryCode: "",
    City: "Boston",
    State: "",
    ZipPostalCode: "02127",
    ExternalId: "",
    PartyId: "",
    IsPrimary: false,
    Email: "esteban.flores@verndale.com",
    ContactId: null
  }],
  Shippings: null,
  Options: null,
  OloFoodStoreBasketId: null,
  OloCateringStoreBasketId: null,
  OloErrors: null,
  FoodDelivery: null,
  OloDiscount: null,
  OloStoreComponent: {
    StoreName: "Ops Lab 8102",
    StoreNumber: "8102",
    StoreAddress: "305 Hartmann Drive",
    StoreCity: "Lebanon",
    State: "TN",
    ZipCode: "37087",
    StorePhone: "6154445533",
    MerchantId: null,
    VendorId: "129973",
    StoreTimeZone: "-5",
    Id: "8c4d7da6a3a1417db4585eb168fc269e",
    Name: "",
    Comments: "",
    Policies: [],
    ChildComponents: []
  },
  UserIp: null,
  DisplayMessages: null,
  UpsellCrossSellCategories: null,
  IsTokenExEnabled: false
}, {
  Status: "Completed",
  OrderNumber: "17324659652100097",
  OrderDate: "Apr 02, 2023",
  Id: "Entity-Order-cdeef6404a5b4825a51a15db0df13198",
  CartLines: [{
    Id: "9cf1d26c8a2e4b599c64f66f2db17ec2",
    Product: {
      SitecoreId: null,
      ProductChainId: null,
      StoreProductId: "40510275",
      ProductVariantId: null,
      DisplayName: null,
      AvailableInventory: 0,
      CurrencySymbol: null,
      ListPrice: null,
      AdjustedPrice: null,
      ImageFilePath: null,
      MinimumQuantity: null,
      MaximumQuantity: null,
      MinimumBasketQuantity: null,
      MaximumBasketQuantity: null,
      DetailLink: null,
      CatalogName: "CB_Food_Store",
      ProductVariantModel: null,
      AdvanceNoticeTimeInHours: null
    },
    Quantity: 1,
    Price: {
      CurrencyCode: "USD",
      CurrencySymbol: "$",
      Total: 0,
      Subtotal: 19.99,
      HandlingTotal: 0,
      ShippingTotal: 0,
      TaxTotal: 0,
      TotalSavings: 0,
      OloTip: null,
      OloCateringTip: null
    },
    Options: null,
    LineCost: 19.99,
    OloBasketId: "748ffb16-99d3-4f1e-ada3-b47996bb8d9b",
    OloBasketProductId: "15844014028",
    Recipient: null,
    SpecialInstruction: null,
    LineOptions: null,
    TrackingNumber: null,
    AddOnProductDetails: null,
    ReturnDetails: {
      Quantity: 0,
      ReturnWindowExpired: false,
      Status: "",
      IsReturnInitiated: false,
      Reason: ""
    }
  }, {
    Id: "c1dab4cc967945d180ad0daaf7223685",
    Product: {
      SitecoreId: null,
      ProductChainId: null,
      StoreProductId: "40510277",
      ProductVariantId: null,
      DisplayName: null,
      AvailableInventory: 0,
      CurrencySymbol: null,
      ListPrice: null,
      AdjustedPrice: null,
      ImageFilePath: null,
      MinimumQuantity: null,
      MaximumQuantity: null,
      MinimumBasketQuantity: null,
      MaximumBasketQuantity: null,
      DetailLink: null,
      CatalogName: "CB_Food_Store",
      ProductVariantModel: null,
      AdvanceNoticeTimeInHours: null
    },
    Quantity: 1,
    Price: {
      CurrencyCode: "USD",
      CurrencySymbol: "$",
      Total: 0,
      Subtotal: 15.99,
      HandlingTotal: 0,
      ShippingTotal: 0,
      TaxTotal: 0,
      TotalSavings: 0,
      OloTip: null,
      OloCateringTip: null
    },
    Options: null,
    LineCost: 15.99,
    OloBasketId: "748ffb16-99d3-4f1e-ada3-b47996bb8d9b",
    OloBasketProductId: "15844022786",
    Recipient: null,
    SpecialInstruction: null,
    LineOptions: null,
    TrackingNumber: null,
    AddOnProductDetails: null,
    ReturnDetails: {
      Quantity: 0,
      ReturnWindowExpired: false,
      Status: "",
      IsReturnInitiated: false,
      Reason: ""
    }
  }],
  Price: {
    CurrencyCode: "USD",
    CurrencySymbol: "$",
    GiftCardTotal: 23.89,
    Total: 44.89,
    Subtotal: 35.98,
    HandlingTotal: 0,
    ShippingTotal: 0,
    TaxTotal: 0,
    TotalSavings: 0,
    OloTip: null,
    OloCateringTip: null
  },
  Adjustments: [],
  Email: null,
  Addresses: [{
    Name: "",
    FirstName: "Esteban",
    LastName: "Flores",
    Address1: "28 DAMRELL STREET, SUITE 300",
    Address2: "",
    Country: "",
    CountryCode: "",
    City: "Boston",
    State: "",
    ZipPostalCode: "02127",
    ExternalId: "",
    PartyId: "",
    IsPrimary: false,
    Email: "esteban.flores@verndale.com",
    ContactId: null
  }, {
    Name: "",
    FirstName: "Esteban",
    LastName: "Flores",
    Address1: "28 DAMRELL STREET, SUITE 300",
    Address2: "",
    Country: "",
    CountryCode: "",
    City: "Boston",
    State: "",
    ZipPostalCode: "02127",
    ExternalId: "",
    PartyId: "",
    IsPrimary: false,
    Email: "esteban.flores@verndale.com",
    ContactId: null
  }],
  Shippings: null,
  Options: null,
  OloFoodStoreBasketId: null,
  OloCateringStoreBasketId: null,
  OloErrors: null,
  FoodDelivery: null,
  OloDiscount: null,
  OloStoreComponent: {
    StoreName: "Ops Lab 8102",
    StoreNumber: "8102",
    StoreAddress: "305 Hartmann Drive",
    StoreCity: "Lebanon",
    State: "TN",
    ZipCode: "37087",
    StorePhone: "6154445533",
    MerchantId: null,
    VendorId: "129973",
    StoreTimeZone: "-5",
    Id: "a96020db9e7b4f9d88f5f1503c7af8c3",
    Name: "",
    Comments: "",
    Policies: [],
    ChildComponents: []
  },
  UserIp: null,
  DisplayMessages: null,
  UpsellCrossSellCategories: null,
  IsTokenExEnabled: false
}]; // const ordersData = [];

var missingCreditData = {
  logo: {
    value: {
      src: "https://i.ibb.co/XpxqNkW/Logo.png",
      alt: "Logo rewards",
      width: "223",
      height: "74"
    }
  },
  onPressAction: {
    value: "crackerbarrel://connect/Contact-Us"
  },
  contactButtonLink: {
    value: "https://guestrelations.crackerbarrel.com/s/contactsupport"
  },
  header: {
    value: "Are you missing PEG credit?"
  },
  description: {
    value: "<p>You can request missing Peg credit up to 30 days after a transaction:</p><ol><li>Please allow 48-72 hours after your transaction for Pegs to appear in your account. Then, check your order history to be sure you didn&rsquo;t receive credit.</li><li>After 72 hours, if Pegs are still missing, go to the &quot;Contact Us&quot; form and choose the &ldquo;Rewards Category&rdquo; in the first field and &ldquo;Missing Pegs&rdquo; in the topic field.</li><li>Be sure to provide your online order number or receipt number in the Comment/Question area.</li></ol>"
  },
  contactButtonLabel: {
    value: "Contact Us"
  },
  legalInfoCopy: {
    value: "<p>Placeholder for any legal language that we need to include to clarify like, please refer to Rewards<a href='http://www.google.com' target='_blank' rel='noopener noreferrer'> Terms and Conditions</a>.</p>"
  }
};
var pegModuleData = {
  freeOrderCopy: {
    value: "Your entire order is on the house!"
  },
  notLoggedInCopy: {
    value: "Sign in to earn Pegs for Rewards."
  },
  pausedAccCopy: {
    value: "You aren't able to earn while your account is paused."
  },
  backgroundShape: {
    value: {
      src: "https://eus-rsg-9cd37598e2c0-xc2-dev-cd.azurewebsites.net/-/media/CrackerBarrel/Rewards/bg-star.png?h=156&w=158&hash=3DF7B54F7069D56AA871A1F8ADA71280",
      alt: "bg shape star",
      width: "158",
      height: "156"
    }
  },
  backgroundImage: {
    value: {
      src: "https://eus-rsg-9cd37598e2c0-xc2-dev-cd.azurewebsites.net/-/media/CrackerBarrel/Rewards/bg.jpg?h=407&w=640&hash=0DEFE91264CBEF031695CCD6CB3BD2FA",
      alt: "background",
      width: "640",
      height: "407"
    }
  },
  orderDetailCopy: {
    value: "You earned # Pegs for this order."
  },
  signInLink: {
    value: {
      href: ""
    }
  },
  imageFreeOrder: {
    value: {
      src: "https://eus-rsg-9cd37598e2c0-xc2-dev-cd.azurewebsites.net/-/media/CrackerBarrel/Rewards/enjoyImage.png?h=74&w=93&hash=9B905553003FA1532CA9AA44A5AAEC6A",
      alt: "bg shape enjoy",
      width: "93",
      height: "74"
    }
  },
  image: {
    value: {
      src: "https://eus-rsg-9cd37598e2c0-xc2-dev-cd.azurewebsites.net/-/media/Project/cb-brandsite/brandsite/images/Loyalty/rewards.png?h=147&w=438&hash=466E11D5D6FB0114EA9B11F5CB421AF8",
      alt: "Rewards Logo",
      width: "438",
      height: "147"
    }
  },
  loggedInCopy: {
    value: "You will earn # Pegs for this order."
  },
  pegCounter: {
    value: "# PEGS"
  },
  infoButton: {
    value: {
      href: ""
    }
  },
  dailyLimitCopy: {
    value: "Daily transaction limit reached. You’ll be back to earning Pegs tomorrow."
  },
  checkoutCopy: {
    value: "You'll earn partial credit for this order as it brings you over 500 Pegs."
  },
  noPegsEarnedCopy: {
    value: "Your account has reached 500 pegs, the most it can have at one time. Redeem some, then keep on earning!."
  }
};
export { ordersData, missingCreditData, pegModuleData };